// src/pages/review/AddAndUpdateReviewPage.js
import React, { useState, useRef } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import ReviewRatingStars from "../../components/course/ReviewRatingStars";
import ReviewContent from "../../components/course/ReviewContent";
import ReviewImage from "../../components/course/ReviewImage";
import ReviewButtonBar from "../../components/course/ReviewButtonBar";
import BackButton from "../../components/common/BackButton";
import {
  updateReviewApi,
  addReviewApi,
  uploadReviewImageApi,
} from "../../api/courseApi";
// [변경] Toast Context 임포트
import { useToast } from "../../contexts/ToastContext";

function AddAndUpdateReviewPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { courseId } = useParams();
  // [변경] useToast 사용
  const { showToast } = useToast();

  const state = location.state || {};
  const mode = state.mode || "add";
  const review = state.review || null;

  const isEdit = mode === "edit" && review;

  const [rating, setRating] = useState(isEdit ? review.reviewRating : 5);
  const [content, setContent] = useState(
    isEdit ? review.reviewContent || "" : ""
  );

  const initialImages = isEdit
    ? (review.reviewImages || []).map((img) => img.image)
    : [];

  const [images, setImages] = useState(initialImages);
  const fileInputRef = useRef(null);

  const handleClickUploadSlot = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleChangeImageFile = async (event) => {
    const fileList = event.target.files;
    if (!fileList || fileList.length === 0) return;

    const files = Array.from(fileList);
    try {
      const uploadedUrls = [];
      for (const file of files) {
        const imageUrl = await uploadReviewImageApi(courseId, file);
        uploadedUrls.push(imageUrl);
      }
      setImages((prev) => [...prev, ...uploadedUrls]);
    } catch (error) {
      console.error(error);
      // [변경] alert -> showToast ('e'rror)
      showToast("이미지 업로드에 실패했습니다.", "e");
    } finally {
      event.target.value = "";
    }
  };

  const handleSubmit = async () => {
    const loginUserId = state.loginUserId;
    const payload = {
      reviewContent: content,
      reviewRating: rating,
      reviewImages: images.map((url) => ({ image: url })),
    };

    try {
      if (isEdit) {
        await updateReviewApi(courseId, review.reviewId, loginUserId, payload);
        // [추가] 성공 메시지
        showToast("후기가 수정되었습니다.", "i");
      } else {
        await addReviewApi(courseId, loginUserId, payload);
        // [추가] 성공 메시지
        showToast("후기가 등록되었습니다.", "i");
      }
      navigate(-1);
    } catch (e) {
      console.error(e);
      // [변경] alert -> showToast ('e'rror)
      showToast("후기 저장에 실패했습니다.", "e");
    }
  };

  return (
    <div className="h-screen overflow-hidden bg-gray-50 flex flex-col max-w-md mx-auto relative font-sans">
      <header className="px-5 pt-6 pb-4 bg-white sticky top-0 z-20 flex items-center justify-between shadow-sm">
        <div className="w-8">
          <BackButton />
        </div>
        <h1 className="text-xl font-bold text-gray-800">
          {isEdit ? "후기 수정" : "후기 작성"}
        </h1>
        <div className="w-8" />
      </header>

      <main className="flex-1 overflow-y-auto px-5 py-6 pb-20 scrollbar-hide space-y-6">
        <section className="bg-white rounded-[24px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 flex flex-col items-center justify-center gap-3">
          <p className="text-sm font-bold text-gray-400">
            이 코스는 어떠셨나요?
          </p>
          <ReviewRatingStars value={rating} onChange={setRating} />
        </section>

        <section className="bg-white rounded-[24px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100">
          <p className="text-sm font-bold text-gray-800 mb-3 ml-1">
            솔직한 후기를 남겨주세요
          </p>
          <ReviewContent
            value={content}
            onChange={setContent}
            readOnly={false}
          />
        </section>

        <section className="bg-white rounded-[24px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100">
          <div className="flex items-center justify-between mb-3 ml-1">
            <p className="text-sm font-bold text-gray-800">사진 첨부</p>
            <span className="text-xs text-gray-400">
              {images.length}장 선택됨
            </span>
          </div>

          <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
            <div className="shrink-0">
              <ReviewImage
                imageUrl={null}
                onClickUpload={handleClickUploadSlot}
              />
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                multiple
                className="hidden"
                onChange={handleChangeImageFile}
              />
            </div>
            {images.map((imageUrl, index) => (
              <div key={index} className="shrink-0">
                <ReviewImage imageUrl={imageUrl} onClickUpload={() => {}} />
              </div>
            ))}
          </div>
        </section>
      </main>

      <div className="fixed bottom-24 left-0 right-0 px-5 max-w-md mx-auto z-30">
        <ReviewButtonBar
          onSubmit={handleSubmit}
          submitText={isEdit ? "수정 완료" : "작성 완료"}
        />
      </div>
    </div>
  );
}

export default AddAndUpdateReviewPage;
